var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightCardHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 1 1 0 0 0)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F9F9F9",
    width: 24,
    height: 24,
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7a1 1 0 0 1 1 1v7.538l2.299-2.271a.948.948 0 0 1 1.41.002c.194.209.292.483.292.757 0 .23-.068.458-.204.65l-.09.11-2.3 2.274a2.87 2.87 0 0 1-2.287.935 1.01 1.01 0 0 1-.24-.002l-.078.005a2.873 2.873 0 0 1-2.208-.938l-2.301-2.274-.09-.11a1.123 1.123 0 0 1-.203-.65c0-.274.097-.548.291-.757a.948.948 0 0 1 1.41-.002L11 15.538V8a1 1 0 0 1 1-1z",
    fill: "#495171"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightCardHistory);
export default __webpack_public_path__ + "static/media/arrow-right-card-history.7d26a3d7c4bfbe915dcb91ca498138d5.svg";
export { ForwardRef as ReactComponent };